import React from 'react';
import { LayoutProps } from 'react-admin';
import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { DashboardProvider } from '../../contexts/DashboardContext';
import { RouterSafeWrapper } from '../common/RouterSafeWrapper';
import { Toaster } from '../ui/sonner';
import { CommandSearch } from '../ui/command-search';

export const AppLayout = ({ children, ...props }: LayoutProps) => {
  // Wrap components that use router hooks in RouterSafeWrapper to prevent
  // useLocation() errors during initial render
  return (
    <DashboardProvider>
      <SidebarProvider>
        <RouterSafeWrapper fallback={
          <div className="flex h-screen">
            <div className="w-64 bg-gray-100 flex items-center justify-center">
              <div className="animate-pulse">Loading sidebar...</div>
            </div>
            <div className="flex-1 flex flex-col">
              <div className="h-16 bg-white border-b flex items-center px-4">
                <div className="animate-pulse">Loading header...</div>
              </div>
              <div className="flex-1 p-4">
                {children}
              </div>
            </div>
          </div>
        }>
          <AppSidebar />
          <SidebarInset className="flex flex-col md:m-0 md:rounded-none md:shadow-none">
            <AppHeader />
            <div className="flex-1 overflow-auto">
              {children}
            </div>
          </SidebarInset>
        </RouterSafeWrapper>
        <CommandSearch />
        <Toaster />
      </SidebarProvider>
    </DashboardProvider>
  );
};